import React, {Component} from 'react';
import PropTypes from "prop-types"

import Sidebar from "../components/Sidebar/Sidebar"
import CartMini from "../components/Cart/CartMini"
import app from "../app.controller"
import "../util.scss"

class PageLayout extends Component {
   render() {
      return (
         <div>
            {/*SHOPPING CART*/}
            <Sidebar open={app.sidebar.open}
                     toggle={app.sidebar.toggle}
                     close={app.sidebar.close}>
               <CartMini> </CartMini>
            </Sidebar>

            {/*MOBILE NAVIGATION*/}
            <Sidebar open={app.mobileNav.open}
                     toggle={app.mobileNav.toggle}
                     close={app.mobileNav.close}>
            </Sidebar>

            {this.props.children}
         </div>
      )
   }
}

PageLayout.propTypes = {
   children: PropTypes.any
}


export default PageLayout



// WEBPACK FOOTER //
// ./src/layout/PageLayout.js